import { render, staticRenderFns } from "./BtnColor.vue?vue&type=template&id=3b18e3b7&scoped=true"
import script from "./BtnColor.vue?vue&type=script&lang=js"
export * from "./BtnColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18e3b7",
  null
  
)

export default component.exports